function DonorActionButtons({
  downloading,
  openExportDonorModal,
  openUploadDonorModal,
  handleBulkUpdateModal,
  openAddModal,
  role,
}) {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-end align-items-stretch align-items-md-center mb-3 gap-2">
      <div className="d-flex flex-column flex-sm-row gap-2">
        <button
          type="button"
          className="btn btn-success btn-round"
          onClick={openExportDonorModal}
          disabled={downloading}
        >
          Export Donor
        </button>

        {/* <button
          type="button"
          className="btn btn-success btn-round"
          onClick={openUploadDonorModal}
        >
          Upload Donor
        </button> */}
        {/* 
        <button
          type="button"
          className="btn btn-success btn-round"
          onClick={handleBulkUpdateModal}
        >
          Bulk Update
        </button> */}

        {role !== "mentor" && (
          <button
            type="button"
            className="btn btn-dark btn-round"
            onClick={openAddModal}
          >
            Add Donor
          </button>
        )}
      </div>
    </div>
  );
}

export default DonorActionButtons;
